import React from "react";
import { useTranslation } from "react-i18next";

// Components
import Modal from "../modal";
import Typography from "../Typography";
import LogoIcon from "../Svgs/LogoIcon";

// Styles
import styles from "./style.module.scss";

interface AvailableSoonModalProps {
  open: boolean;
  onClose: () => void;
}

const AvailableSoonModal: React.FC<AvailableSoonModalProps> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={""}
      showCloseButton
      className={styles.modal}
    >
      <div className={styles.content}>
        <LogoIcon className={`${styles.logo} text-black dark:text-white`} width={150} height={36} />
        <Typography variant="p" className={styles.message}>
          {t('availableSoonModal.message')}
        </Typography>
      </div>
    </Modal>
  );
};

export default AvailableSoonModal;
